export const parseAndPrettyPrintJson = (raw: string): string => {
    try {
        // Remove outer quotes if needed
        if (raw.startsWith('"') && raw.endsWith('"')) {
            raw = raw.slice(1, -1);
        }
        // Unescape backslashes
        raw = raw.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        let parsed: unknown = raw;
        // Keep parsing until it's not a string
        while (typeof parsed === 'string') {
            parsed = JSON.parse(parsed as string);
        }
        return JSON.stringify(parsed, null, 2); // Pretty print
    } catch (e) {
        console.error('Error parsing JSON:', e);
        return raw;
    }
};
